import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {DeliveryNotesModelService} from '../../../Models/Purchases/Delivery-notes/delivery-notes-model.service';
import {DeliveryNoteStatusDto} from '../../../../Models/Purchases/Delivery-notes/delivery-note-status.interface';
import {DeliveryNoteStatusEnum} from '../../../../Shared/Enum/delivery-note-status.enum';
import {DeliverNoteFilters} from '../../../../Models/Purchases/Delivery-notes/deliver-note-filters.model';
import {DeliveryNoteStoreForm, UpdateDeliveryNoteForm, UpdateDeliveryNoteLineForm} from '../../../../Models/Purchases/Delivery-notes/delivery-note-store.model';
import {OrderDto} from '../../../../Models/Purchases/Orders/order.interface';
import {AddSignatureForm} from '../../../../Models/Purchases/Delivery-notes/add-signature-form.model';
import {DeliveryNoteDto} from '../../../../Models/Purchases/Delivery-notes/delivery-note.interface';
import {LinesDto} from '../../../../Models/Purchases/Shared/line.interface';

@Injectable({
  providedIn: 'root'
})
export class DeliveryNotesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: DeliveryNotesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los albaranes
   *
   */
  public getDeliveryNotes(filters: DeliverNoteFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getAlbaranes', filters).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener albarán
   *
   */
  public getDeliveryNote(params: { id_albaran: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getAlbaran', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir albaran
   *
   */
  public setDeliveryNote(params: DeliveryNoteStoreForm | OrderDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAlbaran', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Actualizar albarán
   *
   */
  public updateDeliveryNote(id: number, params: UpdateDeliveryNoteForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`purchases/delivery-notes/${id}`, params, 'patch').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Actualizar la línea del albarán
   *
   */
  public updateDeliveryNoteLine(deliveryNoteId: number, deliveryNoteLineId: number, params: UpdateDeliveryNoteLineForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`purchases/delivery-notes/${deliveryNoteId}/lines/${deliveryNoteLineId}`, params, 'patch').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar la linea del albarán
   *
   */
  public deleteDeliveryNoteLine(deliveryNoteId: number, deliveryNoteLineId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`purchases/delivery-notes/${deliveryNoteId}/lines/${deliveryNoteLineId}`, {
        '_method': 'delete'
      }, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener la información del escaneado del albarán
   *
   */
  public getDeliveryNoteScan(scanId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`purchases/delivery-notes/scans/${scanId}`, {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir albaran por foto
   *
   */
  public addDeliveryNoteByPhoto(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAlbaranFoto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar albarán
   *
   */
  public deleteDeliveryNote(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteAlbaran', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar compra
   *
   */
  public deletePurchases(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteCompraSimple', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar imagen
   *
   */
  public setDeliveryNoteImage(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('editAlbaranFoto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar imagen
   *
   */
  public deleteDeliveryNoteImage(params: { id_albaran: number, id_foto: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteAlbaranFoto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Procesar imágenes escaneadas
   *
   */
  public processScannedImages(id: number, params: FormData): Promise<ApiResponse> {
    params.append('_method', 'PUT');

    return new Promise((resolve, reject) => {

      return this.httpCall(`purchases/delivery-notes/${id}/images`, params, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar firma
   *
   */
  public saveSignature(params: AddSignatureForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAlbaranFirma', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar lineas albaran
   *
   */
  public saveDeliveryNoteLines(params: DeliveryNoteDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAlbaranLineas', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Comprueba la referencia externa
   *
   */
  public checkExternalRef(params: { id_albaran: number, ref: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('checkReferenciaExterna', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar nuevos datos producto
   *
   */
  public saveProduct(product: LinesDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setDatosAlbaranLineas', product, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los estados de un albarán
   *
   */
  getDeliveryNotesStatus(): DeliveryNoteStatusDto[] {
    return [
      {
        id: DeliveryNoteStatusEnum.new,
        nombre: 'CONST.DELIVERY_NOTE_STATUS.NEW'
      },
      {
        id: DeliveryNoteStatusEnum.generated,
        nombre: 'CONST.DELIVERY_NOTE_STATUS.GENERATED'
      },
      {
        id: DeliveryNoteStatusEnum.signed,
        nombre: 'CONST.DELIVERY_NOTE_STATUS.SIGNED'
      },
      {
        id: DeliveryNoteStatusEnum.billed,
        nombre: 'CONST.DELIVERY_NOTE_STATUS.INVOICED'
      }
    ];
  }

}
